import { useState } from 'react';
import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const faqs = [
  {
    q: 'Вы гарантируете продажи?',
    a: 'Мы отвечаем за привлечение и квалификацию заявок. Продажи также зависят от продукта, цены и работы отдела продаж.',
  },
  {
    q: 'Можно подключить CRM?',
    a: 'Да. Передаём заявки в CRM, рабочий чат или напрямую менеджеру.',
  },
  {
    q: 'ИИ заменяет менеджера по продажам?',
    a: 'Нет. ИИ делает первое касание, отвечает на частые вопросы, напоминает клиенту и собирает информацию. Сделку закрывает ваш менеджер.',
  },
  {
    q: 'Сколько занимает запуск?',
    a: 'Обычно тестовый запуск возможен в течение 7–10 дней после согласования условий.',
  },
  {
    q: 'Можно начать с небольшого объёма?',
    a: 'Да. Начинаем с теста, оцениваем качество заявок и затем масштабируем поток.',
  },
];

export default function LTKFAQ() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { containerRef: faqRef, revealedCount: faqRevealed } = useScrollRevealGroup<HTMLDivElement>(5);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span ref={labelRef} className={`text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
            Частые вопросы
          </span>
          <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
            Ответы на популярные вопросы
          </h2>
        </div>

        <div ref={faqRef} className="max-w-2xl mx-auto space-y-3">
          {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={i}
                className={`rounded-2xl bg-background-50 border transition-all duration-300 cursor-pointer reveal-fade-up ${i < faqRevealed ? 'revealed' : ''}`}
                style={i < faqRevealed ? { transitionDelay: `${i * 100}ms` } : undefined}
                onClick={() => toggle(i)}
              >
                <div className={`flex items-center justify-between px-6 py-5 ${
                  isOpen ? 'border-b border-background-200/70' : ''
                }`}>
                  <h3 className="text-[15px] md:text-[16px] font-semibold text-foreground-950 pr-4">{faq.q}</h3>
                  <span className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 transition-all duration-300 ${
                    isOpen ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-100 text-foreground-400'
                  }`}>
                    <i className="ri-add-line text-sm"></i>
                  </span>
                </div>
                {isOpen && (
                  <div className="px-6 py-4">
                    <p className="text-[14.5px] text-foreground-500 leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}